import React from 'react';
import { FatOutlineButton } from './FatOutlineButton';


type GreenOutlineButtonProps = {
    onClick?: () => void;
    type?: 'submit' | 'reset' | 'button';
    text: string;
}
export const FatRedOutlineButton = ({text, onClick, type = 'button'}: GreenOutlineButtonProps) => {
    return <FatOutlineButton text={text} onClick={onClick} type={type} color="red" />;
}
